import 'bootstrap-select';

export default (function () {
    $('.selectpicker').selectpicker({
        liveSearch: true,
        style: '',
        width: '100%',
        styleBase: 'form-control'
    });
}())



// WEBPACK FOOTER //
// ./resources/js/admin/bootstrap-select/index.js